"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const design_system_1 = require("@zapier/design-system");
const GuideLinkContext_1 = require("./GuideLinkContext");
function GuideLink(props) {
    const { onOpenLink } = GuideLinkContext_1.useGuideLinkContext();
    const onClick = () => {
        onOpenLink(props);
    };
    return react_1.default.createElement(design_system_1.Link, { onClick: onClick }, props.children);
}
exports.default = GuideLink;
